module.exports = __webpack_public_path__ + "img/helpyou.83451a9b.jpg";